module.exports = __webpack_public_path__ + "f3b351b4041a0bc3343bff72a8ad0d5f.MP3";